export default __webpack_public_path__ + "static/media/next.17e1708d.svg";